// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  background: var(--theme-main-background-color, #055c8d);
  border: none;
  border-radius: 8px;
  outline: none;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 80px;
  height: 34px;
  padding: 0 16px;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0.331373px;
  text-align: center;
  color: #ffffff;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 160ms ease, opacity 160ms ease, box-shadow 160ms ease;
}

.primary:hover:not(:disabled) {
  background: var(--theme-main-darker-color, #03466c);
}

.primary:focus,
.primary:focus-visible {
  outline: none;
}

.primary:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 92, 141, 0.25);
}

.primary:disabled,
.primary[disabled] {
  background: var(--theme-main-disabled-color, #9ca3af);
  color: black !important;
  cursor: not-allowed;
  opacity: 0.65;
  pointer-events: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
